import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipLogo, TPostClipLogo } from '../types';

export async function postClipLogo(body: TPostClipLogo): Promise<TClipLogo> {
  return mediaManagerClient.post('/api/v1/clip_logos', emptyStringValues(body));
}

type MutationFn = typeof postClipLogo;

type TUsePostClipLogoParams = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
};

type TPostClipLogoSilently = TPostClipLogo & { silently?: boolean };

export function usePostClipLogo({
  config = {},
  invalidateClipQueries = false,
}: TUsePostClipLogoParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...body }: TPostClipLogoSilently) =>
      postClipLogo({ ...(body as TPostClipLogo), silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido crear el logo del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TPostClipLogoSilently) {
      if (!variables.silently) {
        addSuccessNotification(t('El logo del corte se ha creado correctamente'));
      }
      if (invalidateClipQueries) {
        queryClient.invalidateQueries({ queryKey: ['clips'] });
      }
    },
  });
}
